import Vue from 'vue'
import ReportTable from "../components/ReportTable"

let vm={
    components:{ReportTable},
    data:()=>{
        return{
            input_is_show:false,
            is_ranking:true,
            tableColumn:[
                {title:'股票代码',field:"ticker", width:90},  
                {title:'股票简称',field:"short_name", width:80},
                {title:'行业',field:"gics_name", width:120},
                {title:'发布日期',field:'publish_date', width:100,sortType:"date",sortable:true},
                {title:'标题',field:"title", width:270},
                {title:'机构',field:"institution", width:100},
                {title:'研究员',field:"researcher_name", width:150},
                {title:'主题词',field:"subject_words", width:200},
                {title:'创新性',field:"innovation_rate", width:85,sortType:"number",sortable:true},
                {title: "详情", field: "source_url", slots: {default: 'num_default'}},
            ],
        }
    },
}
 

Vue.component("innovation-ranking", vm)
export default vm



// WEBPACK FOOTER //
// ./src/research_report/js/innovation_ranking.js